import { Box, ChevronDownIcon, Flex, Text } from '@radix-ui/themes';
import { Accordion } from 'radix-ui';
import { PropsWithChildren } from 'react';

import styles from './AccordionTrigger.module.css';

interface AccordionTriggerProps extends PropsWithChildren {
    label: string;
}

export const AccordionTrigger = ({
    label,
    children,
}: AccordionTriggerProps) => {
    return (
        <Accordion.Trigger className={styles.accordionTrigger} asChild>
            <Flex align='center' justify='between' px={'2'} py={'3'} gap={'3'}>
                <Text
                    size='2'
                    weight='bold'
                    highContrast
                    wrap={'nowrap'}
                    style={{ userSelect: 'none' }}
                >
                    {label}
                </Text>

                <Box flexGrow={'1'}>{children}</Box>

                <Box flexShrink={'0'} asChild>
                    <ChevronDownIcon className={styles.accordionChevron} />
                </Box>
            </Flex>
        </Accordion.Trigger>
    );
};
